import { render } from "./student-badge.vue?vue&type=template&id=641bc67a&scoped=true&ts=true"
import script from "./student-badge.ts?vue&type=script&lang=ts&external"
export * from "./student-badge.ts?vue&type=script&lang=ts&external"

import "./student-badge.scss?vue&type=style&index=0&id=641bc67a&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641bc67a"]])

export default __exports__